var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.33 9.59469C19.7129 9.9884 19.7429 10.6055 19.4002 11.0346C18.9908 11.547 18.2248 11.5844 17.7675 11.1141L10 3.12627L2.23251 11.1141C1.77524 11.5843 1.0092 11.547 0.599821 11.0346C0.257064 10.6055 0.287134 9.9884 0.669984 9.59469L10 -4.37114e-07L19.33 9.59469Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowImage);
export default __webpack_public_path__ + "static/media/arrow_image.fbb290f9.svg";
export { ForwardRef as ReactComponent };